import {createAction} from "@reduxjs/toolkit";
import * as types from '../../actionTypes';

export const catRevue = createAction(types.CAT_REVUE, (catRevue: any[]) => ({
    payload: catRevue,
}));
